// Repositório de preparação frontend. Contrato de API descrito em docs.
export const papeisVisualizarRamos = ['CLIENTE_VIEW', 'FORNECEDOR_VIEW', 'VENDEDOR_VIEW', 'TECNICO_VIEW', 'COLABORADOR_VIEW', 'TRANSPORTADOR_VIEW']
export const eventoRamosAtualizados = 'escalador:ramos-atividade-atualizados'
const chave = empresaId => `escalador:pessoas:ramos-atividade:v1:${empresaId}`
const normalizar = valor => String(valor || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, ' ').trim().toLowerCase()

export function podeEditarRamos(usuario) {
  return Boolean(usuario?.modules?.includes('COMPANY_ADMIN') || papeisVisualizarRamos.some(role => usuario?.roles?.includes(role.replace('_VIEW', '_EDIT'))))
}

export function listarRamosAtividade(empresaId) {
  if (!empresaId) return []
  const valor = localStorage.getItem(chave(empresaId))
  if (!valor) return []
  const lista = JSON.parse(valor)
  if (!Array.isArray(lista) || lista.some(r => !r || !r.id || typeof r.descricao !== 'string')) throw new Error('Não foi possível ler os ramos de atividade cadastrados.')
  return lista.slice().sort((a, b) => a.descricao.localeCompare(b.descricao, 'pt-BR'))
}

export function encontrarRamoAtividade(lista, descricao) {
  const texto = normalizar(descricao)
  if (!texto) return null
  return lista.find(r => [r.descricao, ...(r.descricoesAnteriores || [])].some(d => normalizar(d) === texto)) || null
}

export function salvarRamoAtividade(empresaId, dados) {
  if (!empresaId) throw new Error('Selecione uma empresa.')
  const descricao = String(dados.descricao || '').trim().replace(/\s+/g, ' ')
  if (!descricao) throw new Error('Informe a descrição do ramo de atividade.')
  if (descricao.length > 120) throw new Error('A descrição deve ter até 120 caracteres.')
  const lista = listarRamosAtividade(empresaId)
  const anterior = dados.id ? lista.find(r => r.id === dados.id) : null
  if (dados.id && !anterior) throw new Error('Ramo de atividade não encontrado. Atualize a listagem.')
  if (encontrarRamoAtividade(lista.filter(r => r.id !== dados.id), descricao)) throw new Error('Já existe um ramo de atividade com essa descrição.')
  const id = anterior?.id || `ramo-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`
  const descricoesAnteriores = [...new Set([...(anterior?.descricoesAnteriores || []), ...(anterior && anterior.descricao !== descricao ? [anterior.descricao] : [])])]
  const ramo = { id, descricao, ativo: dados.ativo !== false, descricoesAnteriores }
  const novos = anterior ? lista.map(r => r.id === id ? ramo : r) : [...lista, ramo]
  localStorage.setItem(chave(empresaId), JSON.stringify(novos))
  if (typeof window !== 'undefined') window.dispatchEvent(new CustomEvent(eventoRamosAtualizados, { detail: { empresaId } }))
  return ramo
}
